<template>
  <div>
    <protocol-header v-if="protocol" :protocol="protocol" class="mb-4"></protocol-header>
    
    <div class="row">
      <div class="col-12">
        <div class="card card-fluid">
          <div class="card-body px-4">
            <div class="form-group mb-2">
              <p class="font-weight-bold">
                Objetivos
              </p>
              <div class="row">
                <div class="col-md-3 d-flex align-items-center justify-content-start"><p>
                  ¿Se incluye en el informe final?
                </p></div>
                <div class="col-md-9">
                  <div class="form-check form-check-inline">
                    <input id="objectives_true"
                           name="objectives" type="radio" disabled :value="true"
                           class="form-check-input"
                           v-model="protocol.final_report.objectives"
                           disabled>
                    <label for="objectives_true" class="form-check-label">Si</label>
                  </div>
                  
                  <div class="form-check form-check-inline">
                    <input id="objectives_false"
                           name="objectives" type="radio" disabled :value="false"
                           class="form-check-input"
                           v-model="protocol.final_report.objectives"
                           disabled>
                    <label for="objectives_false" class="form-check-label">No</label>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="protocol.final_report.objectives === false">
              <div class="form-group mb-4">
                <label for="objectives_reason">Especifique por qué:</label>
                <textarea disabled placeholder=""
                          rows="5"
                          name="objectives_reason"
                          cols="50"
                          id="objectives_reason"
                          class="form-control"
                          v-model="protocol.final_report.objectives_reason"></textarea>
              </div>
            </div>
            
            <hr>
            
            <div class="form-group mb-2">
              <p class="font-weight-bold">
                Resultados
              </p>
              <div class="row">
                <div class="col-md-3 d-flex align-items-center justify-content-start">
                  <p>
                    ¿Se incluye en el informe final?
                  </p>
                </div>
                <div class="col-md-9">
                  <div class="form-check form-check-inline">
                    <input id="results_true" name="results"
                           type="radio" disabled :value="true"
                           class="form-check-input"
                           v-model="protocol.final_report.results">
                    <label for="results_true" class="form-check-label">Si</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input id="results_false"
                           name="results" type="radio" disabled :value="false"
                           class="form-check-input"
                           v-model="protocol.final_report.results">
                    <label for="results_false" class="form-check-label">No</label></div>
                </div>
              </div>
            </div>
            <div v-if="protocol.final_report.results === false">
              <div class="form-group mb-4">
                <label for="results_reason">Especifique por qué:</label>
                <textarea disabled placeholder=""
                          rows="5"
                          name="results_reason"
                          cols="50"
                          id="results_reason"
                          v-model="protocol.final_report.results_reason"
                          class="form-control"></textarea>
              </div>
            </div>
            
            <hr>
            
            <div class="form-group mb-2">
              <p class="font-weight-bold">
                Conclusiones
              </p>
              <div class="row">
                <div class="col-md-3 d-flex align-items-center justify-content-start">
                  <p>
                    ¿Se incluye en el informe final?
                  </p>
                </div>
                <div class="col-md-9">
                  <div class="form-check form-check-inline">
                    <input id="conclusions_true"
                           name="conclusions" type="radio" disabled
                           :value="true"
                           class="form-check-input"
                           v-model="protocol.final_report.conclusions">
                    <label for="conclusions_true" class="form-check-label">Si</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input id="conclusions_false"
                           name="conclusions"
                           type="radio" disabled
                           :value="false"
                           class="form-check-input"
                           v-model="protocol.final_report.conclusions">
                    <label for="conclusions_false" class="form-check-label">No</label>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="protocol.final_report.conclusions === false">
              <div class="form-group mb-4"><label for="conclusions_reason">Especifique por qué:</label>
                <textarea disabled rows="5"
                          name="conclusions_reason"
                          cols="50"
                          id="conclusions_reason"
                          v-model="protocol.final_report.conclusions_reason"
                          class="form-control"></textarea>
              </div>
            </div>
            
            <hr>
            
            <div class="form-group mb-2">
              <p class="font-weight-bold">
                Logros
              </p>
              <div class="row">
                <div class="col-md-3 d-flex align-items-center justify-content-start">
                  <p>
                    ¿Se incluye en el informe final?
                  </p>
                </div>
                <div class="col-md-9">
                  <div class="form-check form-check-inline">
                    <input id="achievements_true"
                           name="achievements"
                           type="radio"
                           disabled
                           :value="true"
                           v-model="protocol.final_report.achievements"
                           class="form-check-input">
                    <label for="achievements_true" class="form-check-label">Si</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input id="achievements_false"
                           name="achievements"
                           type="radio"
                           disabled
                           :value="false"
                           v-model="protocol.final_report.achievements"
                           class="form-check-input">
                    <label for="achievements_false" class="form-check-label">No</label>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="protocol.final_report.achievements === false">
              <div class="form-group mb-4">
                <label for="achievements_reason">Especifique por qué:</label>
                <textarea disabled rows="5"
                          name="achievements_reason"
                          cols="50"
                          id="achievements_reason"
                          v-model="protocol.final_report.achievements_reason"
                          class="form-control"></textarea>
              </div>
            </div>
            
            <hr>
            
            <div class="form-group mb-2">
              <p class="font-weight-bold">
                Productos publicados
              </p>
              <div class="row">
                <div class="col-md-3 d-flex align-items-center justify-content-start">
                  <p>
                    ¿Se incluye en el informe final?
                  </p>
                </div>
                <div class="col-md-9">
                  <div class="form-check form-check-inline">
                    <input id="published_products_true"
                           name="published_products"
                           type="radio"
                           disabled
                           :value="true"
                           v-model="protocol.final_report.published_products"
                           class="form-check-input">
                    <label for="published_products_true" class="form-check-label">Si</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input id="published_products_false"
                           name="published_products"
                           type="radio"
                           disabled
                           :value="false"
                           v-model="protocol.final_report.published_products"
                           class="form-check-input">
                    <label for="published_products_false" class="form-check-label">No</label>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="protocol.final_report.published_products === false">
              <div class="form-group mb-4">
                <label for="published_products_reason">Especifique por qué:</label>
                <textarea disabled rows="5"
                          name="published_products_reason"
                          cols="50"
                          id="published_products_reason"
                          v-model="protocol.final_report.published_products_reason"
                          class="form-control"></textarea>
              </div>
            </div>
            
            <hr>
            
            <div class="form-group mb-2">
              <p class="font-weight-bold">
                Participantes en congresos
              </p>
              <div class="row">
                <div class="col-md-3 d-flex align-items-center justify-content-start">
                  <p>
                    ¿Se incluye en el informe final?
                  </p>
                </div>
                <div class="col-md-9">
                  <div class="form-check form-check-inline">
                    <input id="congress_participants_true"
                           name="congress_participants"
                           type="radio"
                           disabled
                           :value="true"
                           v-model="protocol.final_report.congress_participants"
                           class="form-check-input">
                    <label for="congress_participants_true" class="form-check-label">Si</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input id="congress_participants_false"
                           name="congress_participants"
                           type="radio"
                           disabled
                           :value="false"
                           v-model="protocol.final_report.congress_participants"
                           class="form-check-input">
                    <label for="congress_participants_false" class="form-check-label">No</label>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="protocol.final_report.congress_participants === false">
              <div class="form-group mb-4">
                <label for="congress_participants_reason">Especifique por qué:</label>
                <textarea disabled rows="5"
                          name="congress_participants_reason"
                          cols="50"
                          id="congress_participants_reason"
                          v-model="protocol.final_report.congress_participants_reason"
                          class="form-control"></textarea>
              </div>
            </div>
            
            <hr>
            
            <div class="form-group mb-2">
              <p class="font-weight-bold">
                Estudiantes formados
              </p>
              <div class="row">
                <div class="col-md-3 d-flex align-items-center justify-content-start">
                  <p>
                    ¿Se incluye en el informe final?
                  </p>
                </div>
                <div class="col-md-9">
                  <div class="form-check form-check-inline">
                    <input id="trained_students_true"
                           name="trained_students"
                           type="radio"
                           disabled
                           :value="true"
                           v-model="protocol.final_report.trained_students"
                           class="form-check-input">
                    <label for="trained_students_true" class="form-check-label">Si</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input id="trained_students_false"
                           name="trained_students"
                           type="radio"
                           disabled
                           :value="false"
                           v-model="protocol.final_report.trained_students"
                           class="form-check-input">
                    <label for="trained_students_false" class="form-check-label">No</label>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="protocol.final_report.trained_students === false">
              <div class="form-group mb-4">
                <label for="trained_students_reason">Especifique por qué:</label>
                <textarea disabled rows="5"
                          name="trained_students_reason"
                          cols="50"
                          id="trained_students_reason"
                          v-model="protocol.final_report.trained_students_reason"
                          class="form-control"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12 mb-3">
        <financing-commitments-list :protocol="protocol"
                                    :editable="false"
                                    :financing-commitments="financingCommitments"
                                    @add-financing-commitment="showAddCommitmentDialog"
                                    @remove-commitment="showRemoveCommitmentDialog"></financing-commitments-list>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12">
        <form id="frm-evaluation"
              ref="frm-evaluation"
              @submit.prevent=""
              class="card">
          <div class="card-header">
            <h1 class="card-title mb-0">{{ task.classification.title }}</h1>
          </div>
          
          <div class="card-body px-4">
            <div class="form-group">
              <a :href="`/protocolo/${protocol.id}/consultar`" class="btn btn-lg btn-outline-primary btn-block">
                Ver datos del protocolo
              </a>
            </div>
            
            <div class="form-group">
              <span class="font-weight-bold">Fecha que se recibió</span>
              <span>{{ formatDate(task.created_at) }}</span>
            </div>
            
            <div class="form-group">
              <span class="font-weight-bold">Informe final: </span>
              <a :href="`/${protocol.final_report.file_path}`" target="_blank">{{ protocol.final_report.file_name }}</a>
            </div>
  
            <template v-if="task.evaluation_type === 'committee'">
              <div class="form-group">
                <span class="font-weight-bold">Director de centro: </span>
                <span>{{ protocol.workplace.director ? protocol.workplace.director.full_name : '' }}</span>
              </div>
    
              <div class="form-group" v-if="protocol.final_report.last_evaluation">
                <label class="d-block font-weight-normal"
                       for="comments_director">Comentarios director:
                </label>
                <textarea id="comments_director"
                          class="form-control"
                          name="comments_director"
                          placeholder="Ingrese sus comentarios"
                          rows="5"
                          cols="5"
                          :value="protocol.final_report.last_evaluation.comments"
                          disabled
                          ref="comments_director"></textarea>
              </div>
            </template>
            
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="dictum">Evaluación:
                <abbr style="text-decoration: none;"
                      title="Campo obligatorio">*</abbr>
              </label>
              <select name="dictum"
                      id="dictum"
                      class="form-control"
                      v-model="dictum">
                <option value="" disabled selected>Seleccione una opción</option>
                <option value="1">Aprobado</option>
                <option value="0">No aprobado</option>
              </select>
            </div>
            
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="comments">Comentarios:
                <abbr style="text-decoration: none;"
                      title="Campo obligatorio">*</abbr>
              </label>
              <textarea id="comments"
                        class="form-control"
                        name="comments"
                        placeholder="Ingrese sus comentarios"
                        rows="5"
                        cols="5"
                        v-model="comments"
                        ref="comments"></textarea>
            </div>
            
            <div class="form-group mb-4" v-if="task.evaluation_type === 'committee'">
              <div class="custom-file">
                <input accept="application/pdf"
                       name="file"
                       type="file"
                       id="file"
                       ref="file"
                       class="custom-file-input">
                <label for="file" class="custom-file-label">Adjuntar oficio</label>
              </div>
            </div>
            
            <div class="form-group">
              <button type="button"
                      class="btn btn-primary btn-lg"
                      @click="saveDictum"
                      :disabled="saving">
                <spinner small class="text-white"
                         v-if="saving"
                         :disabled="saving"></spinner>
                Guardar evaluación
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    
    <portal to="financing-modals">
      <financing-commitment-modal ref="financing-commitment-modal"
                                  :funders="funders"
                                  type="protocol"
                                  :add-commitment-function="addCommitment"></financing-commitment-modal>
      
      <ok-cancel-dialog id="delete-commitment-modal"
                        title="Eliminar compromiso"
                        content="<p>¿Está seguro de eliminar el compromiso contraido?</p>"
                        ok-button-text="Eliminar"
                        ok-button-type="danger"
                        @ok-button-pressed="deleteCommitment"
                        @cancel-button-pressed="commitment = null"
                        ref="delete-commitment-modal"></ok-cancel-dialog>
    </portal>
  </div>
</template>

<script>
  import 'jquery-validation'
  import FilesList from '../protocols/FilesList'
  import ProtocolHeader from '../protocols/ProtocolHeader'
  import Spinner from '../ui/Spinner'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import FinancingCommitmentsList from './FinancingCommitmentsList'
  import FinancingCommitmentModal from './FinancingCommitmentModal'
  import autosize from 'autosize'
  import moment from 'moment'
  import { mapActions, mapGetters } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  
  export default {
    name: 'ProtocolFinalReportEvaluation',
    components: {
      OkCancelDialog,
      FilesList,
      ProtocolHeader,
      FinancingCommitmentsList,
      FinancingCommitmentModal,
      Spinner,
    },
    props: {
      protocol: Object,
      task: Object,
    },
    data () {
      return {
        dictum: null,
        comments: '',
        saving: false,
      }
    },
    methods: {
      ...mapActions({
        getFunders: 'protocols/getProtocolFunders',
        getFinancingCommitments: 'protocols/getFinancingCommitments',
        addFinancingCommitment: 'protocols/addFinancingCommitment',
        removeFinancingCommitment: 'protocols/removeCommitment',
        saveFinalReportDictum: 'protocols/saveFinalReportDictum',
      }),
      
      async saveDictum () {
        if (!$(this.$refs['frm-evaluation']).valid()) {
          return false
        }
        
        this.saving = true
        
        const formData = new FormData()
        
        formData.append('protocol', this.protocol.id)
        formData.append('dictum', this.dictum)
        formData.append('comments', this.comments)
        formData.append('type', this.task.evaluation_type)
        
        if (this.task.evaluation_type === 'committee') {
          formData.append('file', this.$refs.file.files[0])
        }
        
        const response = await this.saveFinalReportDictum(formData)
        
        const {
                message,
                error,
                status,
              } = response
        if (status === 'error') {
          AlertManager.error(error)
          
          this.saving = false
          
          return
        }
        
        AlertManager.success(message)
        
        this.saving = true
        
        setTimeout(() => {
          location.href = '/dashboard'
        }, 1200)
      },
      
      formatDate (date) {
        return moment(date).format('DD/MM/YYYY')
      },
      
      showAddCommitmentDialog () {
        $('#financing-commitments-modal').modal('show')
      },
      
      showRemoveCommitmentDialog (commitment) {
        this.commitment = commitment
        
        $('#delete-commitment-modal').modal('show')
      },
      
      async addCommitment (commitment, callback) {
        commitment.protocol = this.protocol
        
        const response = await this.addFinancingCommitment(commitment)
        
        if (response.status === 'success') {
          AlertManager.success(response.message)
          
          await this.getFinancingCommitments(this.protocol)
        }
        else {
          AlertManager.error(response.error)
        }
        
        if (callback) {
          callback()
        }
        
        $('#financing-commitments-modal').modal('hide')
      },
      
      async deleteCommitment () {
        const {
                protocol,
                commitment,
              } = this
        
        const response = await this.removeFinancingCommitment({
          protocol,
          commitment,
        })
        
        if (response.status === 'error') {
          AlertManager.error(response.error)
          
          return
        }
        
        AlertManager.success(response.message)
        
        $('#delete-commitment-modal').modal('hide')
        
        await this.getFinancingCommitments(protocol)
      },
      
      async load () {
        await this.getFunders(this.protocol)
        await this.getFinancingCommitments(this.protocol)
      },

      isAdmin () {
        const roles = ['root', 'administrador']
        
        return this.user && this.user.roles && this.user.roles.some(role => roles.includes(role.key))
      }
    },
    computed: {
      ...mapGetters(['user']),
      ...mapGetters({
        funders: 'protocols/funders',
        financingCommitments: 'protocols/financingCommitments',
      }),
    },
    
    async mounted () {
      const vm = this
      
      $(() => {
        autosize($('textarea'))
        
        $(this.$refs['frm-evaluation']).validate({
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            label.addClass('invalid-feedback')
            label.insertAfter(element)
          },
          rules: {
            dictum: {
              required: true,
            },
            comments: {
              required: true,
            },
            file: {
              required: this.task.evaluation_type === 'committee',
              extension: 'pdf',
              maxsize: (vm.isAdmin() ? 5 : 2) * 1024 * 1024,
            }
          },
          messages: {
            dictum: {
              required: 'Seleccione una opción.',
            },
            comments: {
              required: 'Este campo es requerido.',
            },
            file: {
              required: 'Seleccione el oficio.',
              extension: 'El formato del archivo debe ser PDF.',
              maxsize: `El tamaño del archivo no debe superar los ${ vm.isAdmin() ? 5 : 2 } MB.`,
            },
          },
        })
      })
      
      await this.load()
    },
  }
</script>
